module.exports = __webpack_public_path__ + "media/images/thumb_knee-edff9696.png";